import icons from '@/shared/icons';

export default {
    computed: {
        icons() {
            return icons;
        }
    }
};
